import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import isFunction from 'lodash/isFunction';

import { envConfig } from '../../../config';
import { UploadFilesProps } from '../../app-store/models/upload-files-props.model';
import { Endpoints } from '../utils/endpoints-file.utils';
import { mapFileMetadataDtoToFileMetadataModel } from '../utils/mapping/mapping.utils';
import { sendFileChunks } from '../utils/send-file-chunks.util';
import { sendFile } from '../utils/send.file';

// TODO: RETHINK FILE UPLOAD LOGIC TO AVOID HARD-CODING
export const uploadFiles: AsyncThunk<
  void,
  UploadFilesProps,
  Record<string, unknown>
> = createAsyncThunk(
  'upload-files',
  async (
    {
      file,
      onFileUploadCallback,
      onFileRequestCallback,
      fileType,
      splitIntoChunks = false,
    }: UploadFilesProps,
    thunkAPI
  ) => {
    const resp =
      splitIntoChunks && file.size >= envConfig.app.chunkSize
        ? await sendFileChunks(file, fileType, Endpoints.BASE_LARGE_FILES_PATH)
        : file.type === 'application/x-zip-compressed'
        ? await sendFile(file, fileType, Endpoints.BASE_ZIP_FILES_PATH)
        : await sendFile(file, fileType, Endpoints.BASE_FILES_PATH);

    if (isFunction(onFileUploadCallback)) {
      onFileUploadCallback(file);
    }
    thunkAPI.dispatch(
      onFileRequestCallback(mapFileMetadataDtoToFileMetadataModel(resp.data))
    );
  }
);
